import { useEffect, useMemo, useRef } from "react";
import { Store, Store2 } from "./Store";
import { DisposerTree, disposerTree } from "./disposerTree";

export function useStore<T extends Store>(
  name: string,
  createStore: (dt: DisposerTree) => T,
  _disposerTree?: DisposerTree
): T {
  const store = useMemo(() => {
    const dt = _disposerTree || disposerTree(`${name}(root)`);

    return createStore(dt);
  }, []);

  useEffect(() => {
    return () => {
      store.dt.dispose();
    };
  }, []);

  return store;
}

export function useStore2<T extends Store2<any>>(
  name: string,
  createStore: (dt: DisposerTree) => T,
  _disposerTree?: DisposerTree
): T {
  const storeRef = useRef<T>(null);
  let firstRun = storeRef.current === null;
  if (firstRun) {
    const dt = _disposerTree || disposerTree(`${name}(root)`);
    storeRef.current = createStore(dt);
  }

  if (!firstRun) {
    storeRef.current.useHooks?.(storeRef.current);
  }

  useEffect(() => {
    return () => {
      storeRef.current.dt.dispose();
    };
  }, []);

  return storeRef.current;
}
